import { Colors, Services } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import tag from '@/components/tag'

export default function(h) {
  if (!this.canGetUsersAsResellerUp || !this.username) {
    return null
  }

  let color = Colors.black
  if (this.verified) {
    color = Colors.info
  }

  return h(
    tag,
    {
      props: {
        label: this.username,
        size: sizes.small,
        color,
        tooltip: this.name,
        as: 'link',
        to: {
          name: `${Services.users}.single`,
          params: { id: this.id }
        }
      }
    }
  )
}
